"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLatestVersionHash = exports.clearStorage = void 0;
/**
 * Clears the local storage completely
 * */
exports.clearStorage = () => window.localStorage.clear();
/**
 * Updates the APP_VERSION key in localStorage to latest version
 * @param latestVersion: string - the latest version hash
 * */
exports.updateLatestVersionHash = (latestVersion) => {
    window.localStorage.setItem('APP_VERSION', `"${latestVersion}"`);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9zdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVIOztLQUVLO0FBQ1EsUUFBQSxZQUFZLEdBQUcsR0FBRyxFQUFFLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxLQUFLLEVBQUUsQ0FBQztBQUU5RDs7O0tBR0s7QUFDUSxRQUFBLHVCQUF1QixHQUFHLENBQUMsYUFBcUIsRUFBRSxFQUFFO0lBQy9ELE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLGFBQWEsRUFBRSxJQUFJLGFBQWEsR0FBRyxDQUFDLENBQUM7QUFDbkUsQ0FBQyxDQUFDIn0=